// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bottomSlide":"bottomSlide-hDGD85Qq","logo":"logo-2sFqXrZG","botton":"botton-1jNuhwFB"};